import React from "react";
import Layout from "../../layout/adminExt/Layout";
import Merchants from "./Merchants";

export default function Index() {
  return (
    <Layout>
      <Merchants />
    </Layout>
  );
}
